/**
 * The promotions this till knows about, from its offline copy of the shop.
 *
 * They arrive with the product list, including ones that start later, so a
 * till with no internet still starts a promotion on time. Which are running
 * is checked again every minute - a promotion starting at ten o'clock starts
 * at ten, not at the next refresh.
 */
import { useEffect, useMemo, useState } from 'react';
import { promoRunning, type Promotion } from '@pos/shared';
import { getMeta } from './db.js';
import { useSync } from './sync.js';

export function usePromotions(): Promotion[] {
  const { snapshotAt } = useSync();
  const [promos, setPromos] = useState<Promotion[]>([]);
  useEffect(() => {
    let alive = true;
    void getMeta<{ promotions?: Promotion[] }>('snapshot').then((s) => {
      if (alive) setPromos(s?.promotions ?? []);
    });
    return () => {
      alive = false;
    };
  }, [snapshotAt]);
  return promos;
}

export function useRunningPromotions(): Promotion[] {
  const all = usePromotions();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(timer);
  }, []);
  return useMemo(() => all.filter((p) => promoRunning(p, now)), [all, now]);
}
